import React, { useContext, useMemo } from 'react';
import { Episode } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { SeriesSceneContext } from '../contexts/SeriesSceneContext';
import { EpisodeComponent } from './EpisodeComponent';

export const SeriesEpisodes: React.FC = () => {
	const { series, episodes } = useContext(SeriesSceneContext);

	const episodesComponents = useMemo(() => {
		return episodes?.map((episode: Episode) => <EpisodeComponent key={episode.id} series={series} episode={episode} />) ?? null;
	}, [episodes, series]);

	return <div className={'row'}>{episodesComponents}</div>;
};
